'use client';
import LiteYouTubeEmbed from 'react-lite-youtube-embed';
import Image from 'next/image';

import { getYouTubeID } from '@/src/helpers/getYouTubeID';
import playButton from '@/public/images/pages/play.svg';
import Paragraph from '@/src/components/Typography/Paragraph';

interface YouTubeEmbedProps {
  url: string;
  caption: string;
}

const YouTubeEmbed: React.FC<YouTubeEmbedProps> = ({ url, caption }) => {
  const id = getYouTubeID(url);
  if (!id) return null;
  return (
    <div data-testid="youtube-embed" className="relative group">
      <div className="relative z-10">
        <LiteYouTubeEmbed
          id={id}
          poster="hqdefault"
          noCookie={true}
          title={caption}
        />
      </div>
      <div className="placeholder group-hover:bg-hoverBlue group-hover:drop-shadow-themeY w-full h-full absolute top-0 left-0 border-2 border-black rounded-theme bg-blue flex justify-center items-center">
        <div className="border-black rounded-theme border-2 bg-white py-6 px-12 flex gap-4 items-center">
          <Image
            alt="Click to play embedded youtube video"
            src={playButton}
            height={32}
            width={32}
          />
          <Paragraph text="Click to play video" />
        </div>
      </div>
    </div>
  );
};

export default YouTubeEmbed;
